import styled from "styled-components";
import { Box } from "@mui/material";


export const CMCloseButton = styled.div((props) => ({
  textAlign: "right",
  position: "absolute",
  right: 32,
  top: 28,
  cursor: "pointer",
}));

export const CMwizardFundsBid = {
  height: 600,
  width: 673,
};

export const CMTitleStyle = {
  fontWeight: 500,
  fontSize: 30,
};
export const CMTitleStyleMobile = {
  fontWeight: 500,
  fontSize: 20
}

export const CMwizardConfirmOrder = {
  width: 673,
  height: 780,
};

  export const CMButton = styled.div((props) => ({
    textAlign: "center",
    paddingBottom: 30,
    "& > button": {
      fontWeight: 500,
      fontSize: 28,
      width: 308,
      height: 53,
      padding: "5px 1rem",
      backgroundColor: props.theme.palette.green["700"],
      borderRadius: "30px",
      boxShadow:
        "rgba(0, 0, 0, 0.1) 0px 5px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
      "&:hover": {
        color: "white",
        borderColor: props.theme.palette.green["900"],
        backgroundColor: props.theme.palette.green["900"],
      },
    },
  }));

  export const CMBoxcontainer = styled.div((props) => ({
    display: "flex",
    flexDirection: "column",
  
    "& CMBoxContent": {},
  
    [`@media${props.theme.breakpoints.lg}`]: {
      height: "auto",
    },
  
    [`@media${props.theme.breakpoints.xs}`]: {
      height: "auto",
    },
  }));

  export const CMDisclaimer = styled.div((props) => ({
    width: "98%",
    overflow: "auto",
    maxHeight: "105px",
    marginBottom: "2%",
    marginTop: 17,
    "& p": {
      marginBottom: "1rem",
    },
  
    "&::-webkit-scrollbar": {
      width: "8px",
    },
  
    "&::-webkit-scrollbar-track": {
      backgroundColor: "white",
    },
  
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "6px",
      backgroundColor: props.theme.palette.primary.main,
    },
  }));
  export const CMDisBox = styled(Box)((props) => ({
    textAlign: "left",
    paddingTop: "55px",
    paddingLeft: "6%",
  }));
  